import { c as _c } from "react/compiler-runtime";
import { forwardRef } from "react";
import { cn } from "../utils";
export interface ErrorMessageProps {
  /** Message to display as an error */
  error?: string | undefined;
  /** Classname prop to pass aditional classes */
  classNames?: string | undefined;
}

/**
 * Component rendering a ErrorMessage - typically to be used in the forms sections of the website.
 */
export const ErrorMessage = forwardRef<HTMLDivElement, ErrorMessageProps>((t0, ref) => {
  const $ = _c(8);
  const {
    error,
    classNames
  } = t0;
  let t1;
  if ($[0] !== classNames) {
    t1 = cn("ErrorMessage text-text-feedback-error flex min-h-5", classNames);
    $[0] = classNames;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== error) {
    t2 = Boolean(error) && <span className="typography-component-sm-regular desktop:typography-component-md-regular">{error}</span>;
    $[2] = error;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ref || $[5] !== t1 || $[6] !== t2) {
    t3 = <div ref={ref} className={t1}>{t2}</div>;
    $[4] = ref;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
});
ErrorMessage.displayName = "ErrorMessage";